import BusinessDataRoom from "./BusinessDataRoom";

export default BusinessDataRoom;
